const T = require("react").PropTypes;

const mainViewNames = require("../config.js").MainViewNames;

const defaultMainViewName = mainViewNames[Object.keys(mainViewNames)[0]];

const SurveyType = require("./Survey.js").PropType;
const WalkThruType = require("./WalkThru.js").PropType;
const UserType = require("./User.js").PropType;
const ErrorType = require("./Error.js").PropType;
const MetaAuditType = require("./MetaAudit.js").PropType;
const FacilityType = require("./Facility.js").PropType;
const DistrictType = require("./District.js").PropType;
const DivisionType = require("./Division.js").PropType;
const ReportsType = require("./Reports.js").PropType;
const CompleteReportType = require("./CompleteReport.js").PropType;
const DistrictReportType = require("./DistrictReport.js").PropType; 

const clientScreenWidth = (() => {
    if (window) {
        return window.document.body.getBoundingClientRect().width;
    }

    return 0;
})();

const AppState = {
    PropType: {
        MainViewName: T.string.isRequired,
        SurveyListSearchParameters: T.object,
        CurrentSurvey: SurveyType,
        AuditPeriods: T.array,
        WalkThru: WalkThruType,
        CompleteReport: CompleteReportType,
        DistrictReport: DistrictReportType, 
        LoadingCompleteReport: T.bool, 
        User: T.shape({
            Data: UserType,
            IsLoading: T.bool.isRequired,
            Error: ErrorType
        }),
        Client: T.shape({
            Screen: T.shape({
                IsTiny: T.bool.isRequired,
                IsLarge: T.bool.isRequired
            })
        }),
        AlterEgos: T.shape({
            Data: T.arrayOf(UserType),
            IsLoading: T.bool.isRequired,
            Error: ErrorType
        }),
        ImpersonationTransition: T.shape({
            InProgress: T.bool.isRequired,
            TypeName: T.string.isRequired,
            Error: ErrorType
        }),
        SurveySearchResults: T.shape({
            SelectedFacility: FacilityType,
            Data: T.arrayOf(MetaAuditType),
            IsLoading: T.bool.isRequired,
            Error: ErrorType
        }),
        SurveyCreationStatus: T.shape({
            InProgress: T.bool,
            Error: ErrorType
        }),
        SurveySubmissionStatus: T.shape({
            InProgress: T.bool,
            Error: ErrorType
        }),
        EmailRecipients: T.shape({
            Data: T.arrayOf(T.string),
            IsLoading: T.bool.isRequired,
            Error: ErrorType
        }),
        Reports: ReportsType,
        UnauthorizedError: ErrorType
    },
    Default: {
        MainViewName: defaultMainViewName,
        SurveyListSearchParameters: null,
        AuditPeriods: null,
        CompleteReport: null,
        DistrictReport: null, 
        CurrentSurvey: {
            GUID: null,
            Type: null,
            FacilityNumber: null,
            AuditPeriod: null,
            Pages: null,
            CurrentPageGUID: null,
            CurrentSectionGUID: null,
            IsReadOnly: false,
            IsLoading: false,
            LoadError: null,
            Attachments: [],
            // For dirty-checking the current section's questions
            CurrentQuestionSnapshot: []
        },
        WalkThru: {
            SurveyID: null,
            SurveyType: null,
            SurveyFacilityNumber: null,
            IsLoading: false,
            LoadError: null,
            Data: null
        },
        User: {
            Data: null,
            IsLoading: false,
            Error: null
        },
        // Be sure to keep these synched with components/variables.less.
        Client: {
            Screen: {               
                IsTiny: clientScreenWidth <= 420,
                IsLarge: clientScreenWidth >= 680 
            }        
        },
        AlterEgos: {
            Data: null,
            IsLoading: false,
            Error: null
        },
        ImpersonationTransition: {
            InProgress: false,
            TypeName: "",
            Error: null
        },
        SurveySearchResults: {
            SelectedFacility: null,
            Data: null,
            IsLoading: false,
            Error: null
        },
        SurveyCreationStatus: {
            InProgress: false,
            Error: null
        },
        SurveySubmissionStatus: {
            InProgress: false,
            Error: null
        },
        EmailRecipients: {
            Data: null,
            IsLoading: false,
            Error: null
        },
        Reports: {
            SelectedDivision: null,
            SelectedDistrict: null,
            DateRange: "", 
            CompletedAudits: {
                Data: null,
                Loading: false,
                Error: null
            }
        },
        UnauthorizedError: null
    }
};

console.log("Default app state:", AppState.Default);

module.exports = AppState;


// WEBPACK FOOTER //
// ./src/types/AppState.js